import { call, select, spawn } from 'typed-redux-saga';

import { isRoomAgentMode } from '../../../../../shared/features/config/selectors';
import { selectIsRoomAgentCustomViewportEnabled } from '../../../../../shared/features/flags/selectors';
import { goloomSdk } from '../../../../../shared/features/goloom-sdk';
import { waitForSettingsLoaded } from '../../../../../shared/features/settings/sagas';
import { createLogger } from '../../../../../shared/helpers/loggerFacade';
import { initMuteState } from '../../device';
import { initDevices } from '../../device/sagas/device';

const logger = createLogger('conference:init');

const ROOM_AGENT_CUSTOM_VIEWPORT = {
    width: 1920,
    height: 1080,
};

interface InitConferenceSagaParams {
    syncInitDevices?: boolean;
    reinit?: boolean;
}

export function* initConferenceSaga(params: InitConferenceSagaParams) {
    const { syncInitDevices, reinit } = params;
    const isRoomAgent = yield* select(isRoomAgentMode);

    // Ждём загрузки настроек из localStorage перед инициализацией конференции
    yield* call(waitForSettingsLoaded, 'initConferenceSaga', logger);

    const isRoomAgentCustomViewportEnabled = yield* select(selectIsRoomAgentCustomViewportEnabled);
    if (isRoomAgentCustomViewportEnabled && typeof window.ROOM_AGENT_setViewport === 'function') {
        yield* spawn([window, window.ROOM_AGENT_setViewport], ROOM_AGENT_CUSTOM_VIEWPORT);
    }

    if (reinit) {
        yield* call([goloomSdk, goloomSdk.reinit]);
    } else {
        yield* call([goloomSdk, goloomSdk.init]);
    }

    if (isRoomAgent) {
        return;
    }

    yield* call(initMuteState, { forceCurrentState: reinit });
    if (syncInitDevices) {
        yield call(initDevices);
    } else {
        yield spawn(initDevices);
    }
}
